<template>
  <div
    v-if="data"
  >
    <pages-editions-slug-participants-nav-component
      v-if="imagesData?.length && isDesktop"
    />

    <transition name="fade">
      <pages-editions-slug-participants-images-component
        v-if="showImages && imagesData?.length && isDesktop"
        :items="imagesData"
      />
    </transition>

    <pages-editions-slug-participants-list-component
      v-if="data?.length"
      :data="data"
    />
  </div>
</template>

<script lang="ts" setup>
const route = useRoute()
import { sample } from 'lodash-es'

const { isDesktop } = useDevice()

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})

const imagesData = computed(() => {
  return props?.data?.filter((item: any) => {
    return item?.images?.length
  })?.map((item) => {
    const images = item?.images?.filter(i => imageSizeCheck(i))
    if (!images.length) return
    return {
      ...item,
      image: sample(images)
    }
  })?.filter(i => i?.image?.formats)
})

const hasImagesQuery = computed(() => {
  return route?.query?.view === 'images'
})

const showImages = computed(() => {
  return hasImagesQuery.value && imagesData.value?.length
})
</script>
